<h1 mat-dialog-title>Filter Configuration</h1>
<div mat-dialog-content style="min-height: 650px;">
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Dates" *ngIf="isTabVisible('DateRange')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('DateRange').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('DateRange')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <br />
      <mat-card>
        <mat-card-title>Date Filtering</mat-card-title>
        <mat-card-content>
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Date Range Type</mat-label>
                  <mat-select [(ngModel)]="filterKeys.dateRangeType">
                    <mat-option [value]="0">Fixed Dates</mat-option>
                    <mat-option [value]="1">Range Dates</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="filterKeys.dateRangeType == 0">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="filterKeys.startDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="filterKeys.dateRangeType == 0">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="filterKeys.endDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker ></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="filterKeys.dateRangeType == 1">
                <mat-form-field>
                  <mat-label>Date Range</mat-label>
                  <mat-select [(ngModel)]="filterKeys.dateRange" (selectionChange)="onDateRangeChange()">
                    <mat-option [value]="0">Last 7 Days</mat-option>
                    <mat-option [value]="1">This Month</mat-option>
                    <mat-option [value]="2">Last Month</mat-option>
                    <mat-option [value]="3">This Quarter</mat-option>
                    <mat-option [value]="4">Last Quarter</mat-option>
                    <mat-option [value]="5">This Year</mat-option>
                    <mat-option [value]="6">Last Year</mat-option>
                    <mat-option [value]="7">Trailing Months</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row" *ngIf="filterKeys.dateRangeType == 1 && filterKeys.dateRange == 7">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Number of Months</mat-label>
                  <mat-select [(ngModel)]="filterKeys.trailingMonths">
                    <mat-option *ngFor="let m of trailingMonthOptions" [value]="m">{{m}}</mat-option>
                  </mat-select>
                  <mat-hint>Rolling window ending today</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Companies" *ngIf="isTabVisible('Company')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('Company').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('Company')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <company-search [(ngModel)]="companySelectedValues" [fixedHeight]="500" [showSelected]="true"></company-search>
      </div>
    </mat-tab>
    <mat-tab label="Education Institutions" *ngIf="isTabVisible('EducationInstitution')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('EducationInstitution').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('EducationInstitution')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <education-institution-search [(ngModel)]="educationInstitutionSelectedValues" [fixedHeight]="500" [showSelected]="true"></education-institution-search>
      </div>
    </mat-tab>
    <mat-tab label="Titles" *ngIf="isTabVisible('Title')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('Title').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('Title')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor title-editor">
        <full-title-search [(ngModel)]="titleValues" [fixedHeight]="500"></full-title-search>
      </div>
    </mat-tab>
    <mat-tab label="Industries" *ngIf="isTabVisible('Industry')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('Industry').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('Industry')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <industry-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.industries"></industry-filter-editor>
      </div>
    </mat-tab>
    <mat-tab label="Occupations" *ngIf="isTabVisible('Occupation')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('Occupation').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('Occupation')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <occupation-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.occupations"></occupation-filter-editor>
      </div>
    </mat-tab>
    <mat-tab label="Locations" *ngIf="isTabVisible('Location')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('Location').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('Location')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <mat-radio-group [(ngModel)]="locationType">
          <mat-radio-button [value]="'CleanLocation'">Locations</mat-radio-button>
          &nbsp;&nbsp; <b>OR</b> &nbsp;&nbsp;
          <mat-radio-button [value]="'MetroGroup'">Metro Groups</mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="locationType === 'CleanLocation'">
          <location-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.locations"></location-filter-editor>
        </ng-container>
        <ng-container *ngIf="locationType === 'MetroGroup'">
          <metro-group-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.metroGroups"></metro-group-filter-editor>
        </ng-container>
      </div>
    </mat-tab>
    <mat-tab label="Job Attributes" *ngIf="isTabVisible('JobAttribute')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('JobAttribute').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('JobAttribute')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="editor">
        <attribute-taxonomy-filter-editor [ngClass]="'filter-editor'" [(ngModel)]="filterKeys.attributes"></attribute-taxonomy-filter-editor>
      </div>
    </mat-tab>
    <mat-tab label="Job Postings" *ngIf="isTabVisible('JobPosting')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('JobPosting').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('JobPosting')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <br />
      <mat-card>
        <mat-card-title>Job Posting Filtering</mat-card-title>
        <mat-card-content>
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Postings with Compensation</mat-label>
                  <mat-select [(ngModel)]="postingsWithCompensation">
                    <mat-option [value]="'any'">Any</mat-option>
                    <mat-option [value]="'yes'">Yes</mat-option>
                    <mat-option [value]="'no'">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Minimum Compensation Rate</mat-label>
                  <input matInput type="number" [(ngModel)]="filterKeys.jobPosting.compensationRateMinimum">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Maximum Compensation Rate</mat-label>
                  <input matInput type="number" [(ngModel)]="filterKeys.jobPosting.compensationRateMaximum">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Data Source</mat-label>
                  <mat-select [(ngModel)]="jobPostingDataSource">
                    <mat-option [value]="'indeed'">Indeed</mat-option>
                    <mat-option [value]="'direct'">Direct Employer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab label="Job Postings" *ngIf="isTabVisible('SourceJobPosting')">
      <div class="affected-endpoints" *ngIf="getAffectedEndPoints('SourceJobPosting').length > 0">
        <mat-label>Affected Endpoints:</mat-label>
        <mat-chip-list>
          <mat-chip *ngFor="let ep of getAffectedEndPoints('SourceJobPosting')">{{ep}}</mat-chip>
        </mat-chip-list>
      </div>
      <br />
      <mat-card>
        <mat-card-title>Job Posting Filtering</mat-card-title>
        <mat-card-content>
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Job Type</mat-label>
                  <mat-select [(ngModel)]="primaryJobType">
                    <mat-option [value]="-1">Any</mat-option>
                    <mat-option [value]="0">Implied Full Time</mat-option>
                    <mat-option [value]="1">Full-Time</mat-option>
                    <mat-option [value]="2">Part-Time</mat-option>
                    <mat-option [value]="3">Contract</mat-option>
                    <mat-option [value]="4">Temporary</mat-option>
                    <mat-option [value]="5">Internship</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Job Status</mat-label>
                  <mat-select [(ngModel)]="jobStatus">
                    <mat-option [value]="-1">Any</mat-option>
                    <mat-option [value]="0">Open</mat-option>
                    <mat-option [value]="1">Filled</mat-option>
                    <mat-option [value]="2">Repost</mat-option>
                    <mat-option [value]="3">Event</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Minimum Salary</mat-label>
                  <input matInput type="number" [(ngModel)]="filterKeys.sourceJobPosting.minMidSalary">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Maximum Salary</mat-label>
                  <input matInput type="number" [(ngModel)]="filterKeys.sourceJobPosting.maxMidSalary">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Urgent</mat-label>
                  <mat-select [(ngModel)]="urgent">
                    <mat-option [value]="'any'">Any</mat-option>
                    <mat-option [value]="'yes'">Yes</mat-option>
                    <mat-option [value]="'no'">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Sponsored</mat-label>
                  <mat-select [(ngModel)]="sponsored">
                    <mat-option [value]="'any'">Any</mat-option>
                    <mat-option [value]="'yes'">Yes</mat-option>
                    <mat-option [value]="'no'">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Apply On Indeed</mat-label>
                  <mat-select [(ngModel)]="applyOnIndeed">
                    <mat-option [value]="'any'">Any</mat-option>
                    <mat-option [value]="'yes'">Yes</mat-option>
                    <mat-option [value]="'no'">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Remote Status</mat-label>
                  <mat-select [(ngModel)]="remoteStatus">
                    <mat-option [value]="-1">Any</mat-option>
                    <mat-option [value]="0">Not Listed as Remote</mat-option>
                    <mat-option [value]="1">Hybrid Remote</mat-option>
                    <mat-option [value]="2">Remote (Location Removed)</mat-option>
                    <mat-option [value]="3">Remote (No Location)</mat-option>
                    <mat-option [value]="4">Temporarily Remote</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSaveLayout()">Accept Filter</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel Changes</button>
</div>
